<template>
  <div class="page">
    <div class="page__bd" v-show="!showMark">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO</label>
            <span class="weui-form-preview__value">{{initData.sa_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sa_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.sa_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">{{initData.sa_payments}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{initData.sa_custcontact || ''}}
              {{initData.sa_custmobile || ''}}
              <call-mobile :mobile="initData.sa_custmobile"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收货地址</label>
            <span 
              class="weui-form-preview__value" 
              :class="{
                'weui-form-preview__value-icon': !!initData.sa_toplace,
              }"
            >
              {{initData.sa_toplace}}
              <router-link
                v-if="initData.sa_toplace"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + initData.sa_toplace"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sa_date}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in initData.orderDetails" :key="item.sd_detno">
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户物料编号</label>
            <span class="weui-form-preview__value">{{item.sd_custprodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.sd_custproddetail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.sd_custorispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前数量</label>
            <span class="weui-form-preview__value">{{item.saleChangeDTO.sc_qty_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后数量</label>
            <span class="weui-form-preview__value">{{item.saleChangeDTO.sc_qty_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_price_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_price_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前税率</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_taxrate_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后税率</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_taxrate_new}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label" v-if="item.saleChangeDTO">变更前价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_total_old}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label" v-if="item.saleChangeDTO">变更后价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_total_new}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <div class="weui-form-preview__value text-link" @click="change(item)">
              变更<span class="iconfont icon-refresh"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mark" v-if="showMark"> 
      <div class="page page__has-bar">
        <div class="page__bd">
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">产品编号</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="text" :value="editedForm.sd_prodcode" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">序号</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.sd_detno" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">产品名称</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="text" :value="editedForm.productDTO.pr_detail" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">数量</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.saleChangeDTO.sc_qty_old" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">型号</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.productDTO.pr_orispeccode" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">厂家/品牌</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.productDTO.pr_brand" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">产品规格</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.productDTO.pr_spec" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">数量</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.saleChangeDTO.sc_qty_old" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">已转数</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" :value="editedForm.saleChangeDTO.sd_yqty" disabled />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">含税单价</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" placeholder="请输入" v-model="editedForm.saleChangeDTO.sc_price_new" />
              </div>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">税率%</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" placeholder="请输入" v-model="editedForm.saleChangeDTO.sc_taxrate_new" />
              </div>
            </div>
            <date-field label="交货日期" v-model="editedForm.sd_delivery" />
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">变更原因</label>
              </div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="请输入" v-model="editedForm.sd_remark" />
              </div>
            </div>
          </div>
        </div>

        <div class="footer-bar weui-dialog__ft">
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="() => showMark = false">取消</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";
import DateField from "@/components/field/DateField.vue";

export default {
  components: {
    CallMobile,
    DateField
  },
  props: {
    initData: Object
  },
  data() {
    return {
      showMark: false,
      editedForm: {}
    }
  },
  methods: {
    change(item) {
      var me = this,
        id = item.sd_id
      me.$loading({
        url: '/api/sale/sale/getSaleDetail/' + id,
        method: 'POST'
      }).then(function (res) {
        if (res.success) {
          if(res.data.sd_bussstatuscode == 'CLOSE') {
            me.$weui.topTips('明细行已结案，不能变更', 2000)
            return
          }
          if(res.data.sd_qty == res.data.sd_yqty) {
            me.$weui.topTips('明细行已全部转出货，不能分拆', 2000);
            return
          }
          me.editedForm = item
          me.showMark = true
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    save() {
      let me = this
      if(!me.editedForm.sd_remark) {
        me.$weui.topTips('请填写变更原因', 2000);
        return
      }
      me.doSave()
    },
    doSave() {
      let me = this
      me.$loading({
        url: '/api/sale/sale/modifyDetail',
        method: 'POST',
        jsonData: {
          from_change_id: me.editedForm.saleChangeDTO.id,
          from_code: me.editedForm.saleChangeDTO.sc_code,
          id: me.editedForm.sd_id,
          sd_delivery: me.editedForm.saleChangeDTO.sc_delivery_new,
          sd_netprice: me.editedForm.saleChangeDTO.sc_netprice_new,
          sd_price: me.editedForm.saleChangeDTO.sc_price_new,
          sd_qty: me.editedForm.saleChangeDTO.sc_qty_new,
          sd_remark: me.editedForm.sd_remark,
          sd_taxrate: me.editedForm.saleChangeDTO.sc_taxrate_new,
          splitList: me.editedForm.splitList
        }
      }).then(function (res) {
        if (res.success) {
          me.preLaunchProcess(res.data.change)
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    preLaunchProcess(change) {
      var me = this;
      me.$loading({
        method: "post",
        url: "/api/process/instance/pre_launch",
        jsonData: {
          bizType: change.name,
          bizId: change.id,
          bizCode: change.code,
          viewType: 'sale-change-formpanel'
        }
      }).then(function (res) {
        if (res.success) {
          if (res.data.launched) {
            me.$weui.toast("保存成功", 2000);
          } else {
            me.selectNodeHandler(res.data.items, function (selectedUserMap) {
              me.launchProcess(change, selectedUserMap);
            });
          }
        } else if (res.code == 80001) {
          me.$weui.toast("保存成功", 2000)
        } else {
          me.$weui.topTips(res.message, 3000)
        }
      });
    },
    selectNodeHandler(unselected, callback) {
      var me = this;
      me.$loading({
        url: "/api/account/account/list"
      }).then(function (res) {
        if (res.success) {
          var options = res.data.map(o => {
              return Object.assign(o, {
                  label: o.realname,
                  value: o.id
              });
          });
          var selectedUserMap = {},
            fn = function (i) {
                var unselect = unselected[i];
                if (unselect.handlerType == 1) {
                    var config = {
                        title: `请指定节点${i+1}「${unselect.name}」审批人`,
                        onConfirm: function (r) {
                            if (r.length) {
                                selectedUserMap[unselect.id] = [r[0].id];
                            }
                        },
                        onClose: function () {
                            if (i < unselected.length - 1) {
                                fn(i + 1);
                            } else {
                                callback.call(me, selectedUserMap);
                            }
                        }
                    };
                    if (unselect.handlerList && unselect.handlerList.length) {
                        config.defaultValue = [unselect.handlerList[0].id];
                    }
                    me.$weui.picker(options, config);
                } else {
                    selectedUserMap[unselect.id] = unselect.handler.split(',');
                    if (i < unselected.length - 1) {
                        fn(i + 1);
                    } else {
                        callback.call(me, selectedUserMap);
                    }
                }
            };
          fn(0);
        }
      });
    },
    launchProcess(change, selectedUserMap) {
        var me = this;
        me.$loading({
            method: "post",
            url: '/api/process/instance/launch',
            jsonData: {
                bizType: change.name,
                bizId: change.id,
                bizCode: change.code,
                viewType: 'sale-change-formpanel',
                selectedUserMap
            }
        }).then(function (res) {
            if (res.success) {
                me.$weui.toast("保存成功", 2000);
                me.$router.back(2);
            }
        }).catch(function () {
            me.$weui.topTips("保存失败", 3000);
        });
    },
  }
};
</script>

<style scoped>
.mark {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 500;
  overflow-y: scroll;
}
</style>